import { SectionContainer, SectionHeadline, SectionDivider, SectionSpacer, ChildrenContainer } from "./Sidebar.styled";

interface SidebarSectionProps {
	headline: string;
	children: React.ReactNode;
	isExpanded: boolean;
	isFirst?: boolean;
}

const SidebarSection = ({ children, headline, isExpanded, isFirst = false }: SidebarSectionProps) => {
	return (
		<SectionContainer>
			{isExpanded ? <SectionHeadline $isExpanded={isExpanded}>{headline}</SectionHeadline> : isFirst ? <SectionSpacer /> : <SectionDivider />}
			<ChildrenContainer>{children}</ChildrenContainer>
		</SectionContainer>
	);
};

export default SidebarSection;
